import { useRecoilState, useRecoilValue } from "recoil";
import { artistListState, songRequestListState } from "../atom/atom";
import { SongRequest, Status } from "../types/type";
import { useEffect, useState } from "react";
import { updateSongRequestStatusToComplete } from "../api/update.api";
import { formatDate } from "../tools/tools";
import { fetchAndSetData, fetchSongRequestList } from "../api/fetch.api";

function SongRequestPage() {
  const [songRequestList, setSongRequestList] =
    useRecoilState(songRequestListState);
  const totalArtistList = useRecoilValue(artistListState);
  const [filteredSongRequestList, setFilteredSongRequestList] = useState<
    SongRequest[]
  >([]);
  const [selectedArtist, setSelectedArtist] = useState<string | null>(null);
  const [filterStatus, setFilterStatus] = useState<string>("all");

  useEffect(() => {
    let updatedList = [...songRequestList];

    if (selectedArtist === "others") {
      const artistNames = totalArtistList.map((artist) => artist.artistName);
      updatedList = updatedList.filter(
        (songRequest) => !artistNames.includes(songRequest.artistName)
      );
    } else if (selectedArtist) {
      updatedList = updatedList.filter(
        (songRequest) => songRequest.artistName === selectedArtist
      );
    }

    if (filterStatus === "complete") {
      updatedList = updatedList.filter(
        (songRequest) => songRequest.status === Status.COMPLETE
      );
    } else if (filterStatus === "pending") {
      updatedList = updatedList.filter(
        (songRequest) => songRequest.status === Status.PENDING
      );
    } else if (filterStatus === Status.EXISTING) {
      updatedList = updatedList.filter(
        (songRequest) => songRequest.status === Status.EXISTING
      );
    }

    updatedList.sort((a, b) => b.requestAt.toDate() - a.requestAt.toDate()); // 최신순 정렬
    setFilteredSongRequestList(updatedList);
  }, [selectedArtist, songRequestList, totalArtistList, filterStatus]);

  const handleStatusUpdate = async (songRequest: SongRequest) => {
    try {
      await updateSongRequestStatusToComplete(
        songRequest.songRequestId,
        songRequest.userId
      );
      setSongRequestList((prevList) =>
        prevList.map((request) =>
          request.songRequestId === songRequest.songRequestId
            ? { ...request, status: Status.COMPLETE }
            : request
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAndSetData(fetchSongRequestList, setSongRequestList);
  }, []);

  return (
    <>
      <h1>Song Request Data</h1>
      <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "20px" }}>
        {totalArtistList.map((artist) => (
          <button
            key={artist.artistId}
            onClick={() => setSelectedArtist(artist.artistName)}
            style={{
              margin: "5px",
              padding: "10px",
              border:
                selectedArtist === artist.artistName
                  ? "2px solid #000"
                  : "1px solid #ccc",
            }}
          >
            {artist.artistName}
          </button>
        ))}
        <button
          onClick={() => setSelectedArtist("others")}
          style={{
            margin: "5px",
            padding: "10px",
            border:
              selectedArtist === "others" ? "2px solid #000" : "1px solid #ccc",
          }}
        >
          Others
        </button>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <button
          onClick={() => setFilterStatus("all")}
          style={{
            margin: "5px",
            padding: "10px",
            border:
              filterStatus === "all" ? "2px solid #000" : "1px solid #ccc",
          }}
        >
          전체보기
        </button>
        <button
          onClick={() => setFilterStatus("pending")}
          style={{
            margin: "5px",
            padding: "10px",
            border:
              filterStatus === "pending" ? "2px solid #000" : "1px solid #ccc",
          }}
        >
          Pending
        </button>
        <button
          onClick={() => setFilterStatus("complete")}
          style={{
            margin: "5px",
            padding: "10px",
            border:
              filterStatus === "complete" ? "2px solid #000" : "1px solid #ccc",
          }}
        >
          Complete
        </button>
        <button
          onClick={() => setFilterStatus(Status.EXISTING)}
          style={{
            margin: "5px",
            padding: "10px",
            border:
              filterStatus === Status.EXISTING
                ? "2px solid #000"
                : "1px solid #ccc",
          }}
        >
          Existing
        </button>
      </div>

      {filteredSongRequestList.map((songRequest: SongRequest) => (
        <div
          key={songRequest.songRequestId}
          style={{
            border: "1px solid #ccc",
            margin: "10px",
            padding: "10px",
          }}
        >
          <p>RequestId: {songRequest.songRequestId}</p>
          <p>SongTitle: {songRequest.songTitle}</p>
          <p>ArtistName: {songRequest.artistName}</p>
          <p>Requester: {songRequest.userName}</p>
          <p>Token: {songRequest.userToken}</p>
          <p>Status: {songRequest.status}</p>
          <p>날짜: {formatDate(songRequest.requestAt)}</p>
          {songRequest.status === Status.PENDING && (
            <button
              onClick={() => handleStatusUpdate(songRequest)}
              style={{ padding: "5px", marginTop: "10px" }}
            >
              전송 완료
            </button>
          )}
        </div>
      ))}
    </>
  );
}

export default SongRequestPage;
